export const formatCountdownMmSs = (seconds: number, format: 'verbose' | 'mmss' = 'verbose') => {
	const min = String(Math.floor(seconds / 60)).padStart(2, '0');
	const sec = String(seconds % 60).padStart(2, '0');
	return format === 'mmss' ? `${min}:${sec}` : `${min}m ${sec}s`;
};
